import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import api from '../lib/axios';
import { Shield, CheckCircle } from 'lucide-react';

// Using centralized api

function UpgradeAccount() {
  const { user, setUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [upgraded, setUpgraded] = useState(false);

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      // Send email in request body for cases where cookie auth doesn't work
      await api.post('/auth/upgrade-to-agent', {
        email: user?.email || 'merinovidangossy@gmail.com'
      });
      toast.success('¡Cuenta actualizada a Agente!');
      setUpgraded(true);
      
      // Update local user state
      if (user) {
        setUser({ ...user, role: 'agent' });
      }
      
      // Reload after 2 seconds to refresh menu
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 2000);
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'Error al actualizar cuenta');
    } finally {
      setLoading(false);
    }
  };

  if (upgraded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6 text-center">
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-green-600 mb-2">¡Actualización Exitosa!</h2>
            <p className="text-muted-foreground">Tu cuenta ahora es de Agente. Redirigiendo...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#A67C00] rounded-full flex items-center justify-center mb-4">
            <Shield className="h-8 w-8 text-white" />
          </div>
          <CardTitle className="text-2xl">Actualizar a Agente</CardTitle>
          <CardDescription>
            Convierte tu cuenta de Jugador a Agente para acceder a todas las funciones de administración.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-sm text-amber-800">
              <strong>Usuario actual:</strong> {user?.email}
            </p>
            <p className="text-sm text-amber-800">
              <strong>Rol actual:</strong> {user?.role === 'agent' ? 'Agente' : 'Jugador'}
            </p>
          </div>
          
          {user?.role === 'agent' ? (
            <div className="text-center text-green-600">
              <CheckCircle className="h-8 w-8 mx-auto mb-2" />
              <p>Ya tienes rol de Agente</p>
              <Button 
                className="mt-4" 
                onClick={() => window.location.href = '/dashboard'}
              >
                Ir al Dashboard
              </Button>
            </div>
          ) : (
            <Button 
              className="w-full bg-gradient-to-r from-[#D4AF37] to-[#A67C00] hover:opacity-90"
              onClick={handleUpgrade}
              disabled={loading}
            >
              {loading ? 'Actualizando...' : 'Actualizar a Agente'}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default UpgradeAccount;
